import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

type MaplibreWorkerConfiguration = {
    readonly setWorkerUrl: (workerUrl: string) => void;
};

export function configureMaplibreWorker({
    setWorkerUrl,
}: MaplibreWorkerConfiguration) {
    setWorkerUrl(maplibreWorkerUrl);
}

// Shared map constants for MapLibre surfaces (admin org distributions,
// coverage dashboard). OpenFreeMap tiles need no API key.
export const MAP_STYLE = 'https://tiles.openfreemap.org/styles/positron';

export const OFFICE_COLORS = [
    '#2563eb',
    '#16a34a',
    '#dc2626',
    '#ca8a04',
    '#7c3aed',
    '#0891b2',
    '#db2777',
    '#65a30d',
    '#ea580c',
    '#4f46e5',
];

export const UNASSIGNED_OFFICE_COLOR = '#64748b';
